import RssFeedContainer from 'modules/posts/containers/RssFeedContainer';

const RssFeedView = props => <RssFeedContainer {...props} />;

export default RssFeedView;
